<template>
<div class="pagewide panel mtpage landingpage">


	<maincontent>
		<template v-slot:content>

            <template v-if="locale == 'ru'">

                <div class="slide slide1">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>Snippity + Ты = Умные малыши и довольные блогеры</span>
                        </div>
                        <div class="subcaption">
                            <span>Делись своим промокодом — получай деньги и радость. До 20% дохода тебе, до 10% скидки подписчикам.</span>
                        </div>
                    </div>
                </div>

                <!--<div class="storyWrapper">
                    <story ref="story" :nocontrols="true" :id="'bd7b551b-6151-cccc-9333-38edfc08c8e8'"/>
                </div>-->


                <div class="slide slide2">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🧸 Что такое Snippity?</span>
                        </div>
                        <div class="paragraph">
                            <div>Snippity — это новостное приложение для детей.</div>
                            <div>Да, ты не ослышался!</div>
                            <div>Малыши теперь тоже в курсе, что происходит в мире — только всё понятно, доброжелательно и в стиле сказки.
                            Это не просто приложение. Это забота, образование и магия каждый день.</div>
                        </div>

                    </div>
                </div>

                <div class="slide slide3">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span> 💡 Как всё устроено:</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Регистрируешься — быстро и просто</li>
                                <li>Получаешь свой личный промокод</li>
                                <li>Рассказываешь подписчикам — в сторис, постах или видео</li>
                                <li>Рассказываешь подписчикам — в сторис, постах или видео</li>
                                <li>За каждую покупку с кодом: Ты получаешь до 20%; Твои подписчики получают скидку до 10%</li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="slide slide4">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🚀 Почему блогерам это заходит:</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Продукт, который хочется рекомендовать</li>
                                <li>Детская аудитория = верные, лояльные, активные родители</li>
                                <li>Милая визуалка и заботливая миссия</li>
                                <li>Простой способ монетизации и минимум технических заморочек</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide4">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🖐 Готов попробовать?</span>
                        </div>
                        <div class="paragraph">
                            <div>Жми на кнопку, регистрируйся, заполняй форму — и начинай зарабатывать, просто делясь добром.</div>
                            <div>Snippity ждёт тебя 🌟</div>
                        </div>
                        <div class="calltoaction">
                            <button class="button" @click="becomepartnership">{{$t('plans.becomepartnership')}}</button>
                        </div>
                        
                    </div>
                </div>





		    </template>

            <template v-if="locale == 'en'">
                <div class="slide slide1">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>Snippity + You = Smart kids and happy bloggers</span>
                        </div>
                        <div class="subcaption">
                            <span>Share your promo code - get money and joy. Up to 20% of income for you, up to 10% discount for subscribers.</span>
                        </div>
                    </div>
                </div>

                <div class="slide slide2">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🧸 What is Snippity?</span>
                        </div>
                        <div class="paragraph">
                            <div>Snippity is a news app for kids.</div>
                            <div>Yes, you heard right!</div>
                            <div>Kids are now also aware of what is happening in the world - only everything is clear, friendly and in the style of a fairy tale.
                        This is not just an app. It's care, education and magic every day.</div>
                        </div>
                    </div>
                </div>

                <div class="slide slide3">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span> 💡 How it all works:</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Register — quick and easy</li>
                                <li>Get your personal promo code</li>
                                <li>Tell your subscribers — in stories, posts or videos</li>
                                <li>Tell your subscribers — in stories, posts or videos</li>
                                <li>For each purchase with the code: You get up to 20%; Your subscribers get a discount of up to 10%</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide4">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🚀 Why bloggers like it:</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>A product you want to recommend</li>
                                <li>Children's audience = loyal, faithful, active parents</li>
                                <li>Cute visuals and a caring mission</li>
                                <li>A simple way to monetize and a minimum of technical hassle</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide4">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🖐 Ready to try?</span>
                        </div>
                        <div class="paragraph">
                            <div>Click the button, sign in, fill out the form — and start earning, just sharing goodness.</div>
                            <div>Snippity is waiting for you 🌟</div>
                        </div>
                        <div class="calltoaction">
                            <button class="button">{{$t('plans.becomepartnership')}}</button>
                        </div>
                    </div>
                </div>
            </template>

           

            <div class="brandWrapper">
                <logotype :big="true"/>
            </div>

            <div class="footerWrapper">
	            <footerComponent />
            </div>

		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	
.slide1
    background: #fdfdd0
    color : #000

.slide2
    border-bottom: $r solid #fdfdd0

.slide3
    border-bottom: $r solid #dc0050

</style>

<script>

import { mapState } from 'vuex';
import story from "@/components/modules/stories/story/index.vue";


export default {
	name: 'landing_partnership_page',
	components: {
        story
	},

	data : function(){
		return { 
			searchEnabled : false,
            locales : {en : true, ru : true}

		}
	},

	computed: mapState({
		auth : state => state.auth,
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        },

        userinfo : state => state.userinfo?.userinfo,
	}),

	methods: {
		becomepartnership : function(){
            if(!this.auth){
                this.$router.push('/registration?type=blogger').catch(e => {})

                return
            }

            if(this.userinfo){
                if (this.userinfo.type == 4){
                    this.core.sitemessage(this.$t('plans.becomedpartnership'))
                    this.$router.push('/panel/partnerinfo').catch(e => {})

                    return
                }
                
                if (this.userinfo.type == 0){

                    this.signoutAndGoQuestion()

                    return
                }
            }

            this.core.sitemessage(this.$t('plans.becomedpartnership'))
        },

        changeUserType : function(){

            this.core.promwrapper(this.core.api.user.typechange(4)).then(() => {
                this.$router.push('/panel/partnerinfo').catch(e => {})
            }).catch(e => {})


        },

        changeUserTypeQuestion : function(){
            this.$dialog.confirm(
				this.$t('plans.becomepartnershipTypeQuestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {
				this.changeUserType()
			}).catch( e => {
				
			})
        },

        signoutAndGoQuestion : function(){
            this.$dialog.confirm(
				this.$t('plans.becomedpartnershipchangeaccount'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

				this.core.user.signout().then(() => {
                    this.$router.push('/registration?type=blogger').catch(e => {})
                })

			}).catch( e => {
				
			})
        }
	},

	mounted() {

	}
}
</script>
